import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrRuleTemplateCategory.ts
var t = () => e("ruleTemplateCategory");
//#endregion
export { t as useTrRuleTemplateCategory };
